module.exports = __webpack_public_path__ + "static/media/trooprlogo1.f7dee225.svg";